import { isArray } from 'lodash-es';

export const getValidationError = (validationMessages, param) => {
  let message = null;

  if (validationMessages && param && validationMessages.length) {
    const messageObject = validationMessages.find((value) => value.param.toLowerCase() === param.toLowerCase());

    if (messageObject) {
      message = messageObject.userMessage;
    }
  }

  return message;
};

export const setValidationError = (errorMessage, param) => {
  const errors = [];

  if (errorMessage && param) {
    errors.push({ param, userMessage: errorMessage });
  }

  return errors;
};

export const setMultipleValidationErrors = (errorMessages) => {
  const errors = [];

  if (isArray(errorMessages)) {
    errors.push(...errorMessages.map((errValue) => ({ param: errValue.param, userMessage: errValue.userMessage })));
  }

  return errors;
};
